import styled from '@emotion/styled'
import { theme, themeUtils } from 'styles/theme'

export const SelectSXProps = {
  width: '100%',
  minWidth: '200px',
  height: '44px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.surface.secondary}`,
  boxSizing: 'border-box',
  ...theme.typography.bodyLRegular,
  backgroundColor: `${theme.palette.surface.default}`,
  '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': {
    paddingTop: 0,
    paddingBottom: 0
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0
  },
  '& .MuiInputBase-input': {
    paddingTop: '20px'
  }
}

export const SelectSXErrorProps = {
  backgroundColor: '#ffeded',
  borderColor: '#ff6666'
}

export const AutocompleteTextFieldSXProps = {
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0
  },
  '& .MuiInputBase-root': {
    height: '44px'
  },
  '& .MuiInputBase-input': {
    '::placeholder': {
      color: 'black',
      opacity: 1,
      ...theme.typography.bodyMRegular
    },
    ...theme.typography.bodyLRegular,
    padding: '0px 0px 3px 5px'
  }
}

export const MenuItemDisplay = styled.span`
  ${themeUtils.bodySmall};
`
